/* eslint-disable no-shadow */
export enum TransferInstructionsEnum {
  All = "All",
  Dollar = "Dollar",
  Percent = "Percent"
}
/* eslint-enable no-shadow */
